<template>
    <div class="content-wrapper">
        <div class="row">
            <div class="col-sm-12 col-md-6">
                <app-breadcrumb :page-title="$t('city')" :directory="$t('master')" :icon="'grid'"/>
            </div>
            <div class="col-sm-12 col-md-6 breadcrumb-side-button">
                <div class="float-md-right mb-3 mb-sm-3 mb-md-0">
                    
                </div>
            </div>
        </div>

        <div class="row">
            <embed class="pdfobject" type="application/pdf" title="PDF" :src="content" style="overflow: auto; position: absolute; inset: 0px; width: 100%; height: 100%;">
        </div>
    </div>

</template>


<style>
    .pdfobject-container {
        height: 30rem;
        border: 1rem solid rgba(0, 0, 0, .1);
    }
</style>

<script>

export default {
    name: "PrintViewer",
    props: {
        content: String
    },
    inject: ["eventHub"],
    created() {
        this.eventHub.$on('message', val => {
            console.log(val);
        });
    },
    mounted() {
        this.eventHub.$emit('message', 'Gal Gadot');
    }
}
</script>